import axios from 'axios';
import axiosInstance from '../../helpers/interceptor';
import { userHotelDetails } from '../../helpers/handleBrandAndHotelData';

export const getProfileCVs = async () => {
  const { data } = await axiosInstance.get(`${Env.API_URL}/profile-cv`);
  return data;
};

export const addProfileCVs = async (cvValues) => {
  const {userData} = userHotelDetails();
  const { data } = await axios.put(`${Env.API_URL}/profile-cv`, cvValues, {
    headers: {
      Authorization: `Bearer ${userData.accessToken}`,
    },
  });
  return data;
};

export const getHotels = async (queryParams) => {
  const { data } = await axiosInstance.get(
    `${Env.API_URL}/hotel?pageSize=20&page=1&sort=name&name=${queryParams.name}`
  );
  return data;
};

export const getLocationInfo = async (locationId) => {
  const { data } = await axiosInstance.get(
    `${Env.API_URL}/location/${locationId}`);
  return data;
};

export const getHotelInfo = async (hotelId) => {
  const { data } = await axiosInstance.get(
    `${Env.API_URL}/hotel/${hotelId}` );
  return data;
};
